export default __webpack_public_path__ + "static/media/github.32b9ac0d.svg";